import { apiClient } from "@/api/client";
import type { Paginated } from "@/types/common";
import type { DriverChangeRequest, DriverChangeStatus } from "@/types/domain";

/** Driver edits to name / email / vehicle details that need admin approval. */
export const driverChangesApi = {
  list: (params: { status?: DriverChangeStatus; page?: number; limit?: number }) =>
    apiClient.get<Paginated<DriverChangeRequest>>("/admin/driver-changes", { params }).then((r) => r.data),
  approve: (id: string) =>
    apiClient.post<DriverChangeRequest>(`/admin/driver-changes/${id}/approve`).then((r) => r.data),
  reject: (id: string, reason: string) =>
    apiClient.post<DriverChangeRequest>(`/admin/driver-changes/${id}/reject`, { reason }).then((r) => r.data),
};
